import clsx from 'clsx';
import { LoaderCircle } from 'lucide-react';

export type SpinnerSize = 'sm' | 'md' | 'lg';

const SIZE_CLASSES: Record<SpinnerSize, string> = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-9 w-9',
};

export interface SpinnerProps {
  size?: SpinnerSize;
  /** Подпись под индикатором; также уходит в aria-label. */
  label?: string;
  className?: string;
}

export function Spinner({ size = 'md', label, className }: SpinnerProps) {
  return (
    <div
      className={clsx('flex flex-col items-center justify-center gap-2 text-slate-500', className)}
      role="status"
      aria-live="polite"
      aria-label={label ?? 'Загрузка'}
    >
      <LoaderCircle className={clsx('animate-spin text-brand-600', SIZE_CLASSES[size])} aria-hidden />
      {label ? <span className="text-sm">{label}</span> : null}
    </div>
  );
}

/** Заполняет доступную высоту — заглушка для Suspense внутри страниц. */
export function SectionSpinner({ label = 'Загрузка данных…' }: { label?: string }) {
  return (
    <div className="flex min-h-[240px] w-full items-center justify-center">
      <Spinner label={label} />
    </div>
  );
}
